<template>
  <!-- Start Wrapper Main -->
  <div class="wrapper__main wishlist-page">
    <!-- Start Heading page -->
    <div class="heading-page">
      <div class="menu-title">
        <div class="container">
          <div class="menu-items row">
            <div class="col-xs-12">
              <ul>
                <li><router-link to="/"> Home</router-link> <span>› </span></li>
                <li><strong>Wishlist</strong></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="page-title">
        <h2>My Wishlist</h2>
      </div>
    </div>
    <!-- End Heading page -->

    <!-- Start My Wishlist Section -->
    <div class="container">
      <div class="" v-if="!loaded">
        <p class="p-2 h3 text-center text-primary">Loading...</p>
      </div>
      <div class="wishlist-products table-responsive" v-if="products.length">
        <form action="#">
          <div>
            <table class="page-table data-table table-striped">
              <colgroup>
                <col width="1" />
                <col />
                <col width="1" />
                <col width="1" />
                <col width="1" />
                <col width="1" />
                <col width="1" />
              </colgroup>
              <thead>
                <tr>
                  <th rowspan="1">&nbsp;</th>
                  <th rowspan="1"></th>
                  <!-- <th rowspan="1">QUANTITY</th> -->
                  <th colspan="1"><span class="fixed-br">Price</span></th>
                  <th rowspan="1"></th>
                  <th colspan="1"></th>
                  <th rowspan="1">&nbsp;</th>
                </tr>
              </thead>
              <tbody>
                <WishedProduct v-for="product in products" :key="product.id" :product="product" @removeItem="removeFromWishList"/>
              </tbody>
              <tfoot>
                <tr class="table-footer">
                  <td colspan="50" class="buttons-table">
                    <!-- <button type="button" class="btn-share">
                      <span>Share Wishlist</span>
                    </button> -->
                    <button type="button" class="btn-add" @click="addAllToCart()">
                      <span>Add All to Cart</span>
                    </button>
                    <!-- <button type="button" class="btn-update">
                      <span>Update Wishlist</span>
                    </button> -->
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </form>
      </div>

      <div class="" v-if="!products.length && loaded">
        <p class="p-2 text-center h3">There are no items.</p>
      </div>
    </div>
    <!-- End My Wishlist Section -->
  </div>
  <!-- End Wrapper Main -->
</template>
<script>
import WishedProduct from "@/components/WishedProduct";
import {mapMutations} from 'vuex';
import Swal from 'sweetalert2';
export default {
  data() {
    return {
      products: [],
      loaded: false
    };
  },
  components: {
    WishedProduct,
  },
  computed: {
    api() {
      return this.$store.state.api;
    },
  },
  mounted() {
    fetch(`${this.api}/client/wishlist/products`, {
      headers: {
        Authorization: localStorage.getItem("care_user_auth_token"),
      },
    })
    .then(res => res.json())
    .then(data => {
      this.loaded = true;
      console.log(data);
      this.products = data.data;
    })
  },
  methods:{
    ...mapMutations(["addAllToShopCart"]),
    removeFromWishList(id){
      console.log(id);
      this.products = this.products.filter(p => p.id != id)
    },
    addAllToCart(){
      this.addAllToShopCart(this.products || []);
      Swal.fire({
        title: 'Success!',
        text: 'All products added to cart',
        icon: 'success',
        confirmButtonText: 'OK.'
      })
    }
  }
}
</script>
